import Chip from "@mui/material/Chip";
import { pillClass } from "../data/model";
import { toneChipColor } from "./tone";

/** Budget-utilization status badge: "g" = under budget, "a" = near limit, "r" = over budget. */
export function StatusBadge({ status }: { status: "g" | "a" | "r" }) {
  const label = status === "g" ? "Under Budget" : status === "a" ? "Near Limit" : "Over Budget";
  return <Chip size="small" label={label} color={toneChipColor(status)} variant="outlined" />;
}

const PILL_COLOR: Record<string, "default" | "info" | "warning" | "success" | "error"> = {
  Draft: "default",
  Validated: "info",
  Review: "warning",
  Approved: "success",
  Published: "success",
  Rejected: "error",
  Rolledback: "warning",
  Revision: "warning",
  Frozen: "default",
};

/** Workflow-state pill (Draft / Under Review / Approved / Frozen / Published / Rejected / Revision / Rolled Back). */
export function StatusPill({ status }: { status: string }) {
  const cls = pillClass(status);
  return <Chip size="small" label={status} color={PILL_COLOR[cls] ?? "default"} />;
}
